var Numeric = require("./Numeric"),
	Customizing = require("../Customizing");

/**
 * The Currency class represents a currency data type. It handles the
 * formatting and accepts several options like second property for
 * the unit of measurement or if the unit of measurement should be
 * displayed.
 *
 * It styles currencies with its particular amount of decimals.
 *
 * @param {Object} oConfig A configuration object that is used to specify the formatting
 * @constructor
 */
function Currency(oConfig) {
	Numeric.call(this, oConfig);
}

Currency.prototype = Object.create(Numeric.prototype);
Currency.prototype.constructor = Currency;

/**
 * Returns the currency specific scale.
 *
 * @param {string} sCurrencyCode ISO currency code like USD for $ and EUR for € etc.
 * @returns {number} A number between 2 and 3 depending on the scale of the given currency
 * @public
 */
Currency.prototype.getScale = function(sCurrencyCode) {
	return Customizing.getScaleForCurrency(sCurrencyCode);
};

/**
 * Returns the numberFormat id of the built-in format or a numberFormat object with the formatting template
 *
 * @param {string} sUnit Unit of measure that is used to resolve the unit specific scale
 * @returns {string} Template for the NumberFormat
 */
Currency.prototype.getNumberFormatTemplate = function(sUnit) {
	let scale, template = '#,##0';

	/* Apply fixed scale, only if no unitProperty is provided */
	if (!sUnit && typeof this.scale === "number") {
		scale = this.scale;
	} else {
		scale = this.getScale(sUnit);
	}

	/* Apply separator or placeholder */
	template += (scale > 0) ? "." : "_.";

	for (let i = 0; i < scale; i++) {
		template += "0";
	}

	for (let j = Customizing.MAX_CURRENCY_SCALE - scale; j > 0; j--) {
		template += "_0";
	}

	/* Add unit of measurement if required */
	if (this.displayUnit) {
		const unitTemplate = sUnit ? `"${sUnit}"` : "_E_U_R";

		// Applies unit of measure or a placeholder if unit is empty
		template += `\\ ${unitTemplate}`;
	}

	return `* ${template};* \\-\\ ${template}`;
};

/**
 * Creates the Style configuration needed for registering the Type
 * specific styling in the Styles class.
 *
 * @param {Object} oData Business object that gets bound to the styling template
 * @returns {Object} Styling configuration object
 * @protected
 */
Currency.prototype._createConfiguration = function(oData) {
	const unit = this.getUnit(oData);
	const template = this.getNumberFormatTemplate(unit);

	return { numberFormat: { format: template } };
};

module.exports = Currency;